<template>
	<div class="page">
		<div class="promo-summary with-v-gap">
			<h1>Your Promotion</h1>

			<div class="column-container">
				<div class="promotion-contents">
					<div class="selected-entities with-v-gap">
						<h2>Event{{basketEntities.length > 1 ? 's' : '' }}</h2>
						<ul>
							<li v-for="entity in basketEntities">
								<h3 class="what">{{ entity.name }}</h3>
								<p>{{entity | eventDateSummary}} at {{ entity.venueSummary | venueNameAndTown }}</p>
							</li>
						</ul>
					</div>

					<div v-if="addOns.length > 0" class="selected-add-ons with-v-gap">
						<h2>Bonus Buttons</h2>
						<ul>
							<li v-for="addOn in addOns">
								{{ addOn.displayName }}
							</li>
						</ul>
					</div>

					<div class="audience with-v-gap">
						<h2>Audience</h2>
						<p class="selected-promotion">
							Promotion to be sent/served to audience of: <strong>{{ basket.impressions.toLocaleString() }}</strong> from
							{{ new Date(basket.startIso) | shortDate }} until {{ new Date(basket.endIso) | shortDate }}
						</p>
					</div>
				</div>

				<div class="payment-column">
					<div class="payment">
						<h2>Total</h2>
						<table>
							<tr>
								<th>ITEM</th>
								<th>COST</th>
								<th>VAT</th>
							</tr>
							<tr v-for="invoiceItem in itemizedList">
								<td>{{invoiceItem.name}}</td>
								<td>{{invoiceItem.costLabel}}</td>
								<td>{{invoiceItem.vatLabel}}</td>
							</tr>
						</table>
						<div class="price-big">{{ netPriceLabel }}</div>
						<div class="price-small with-v-gap">+ {{ vatPriceLabel }} VAT</div>
						<a @click="beginPayment" class="button gradient-filled sunset pay with-v-gap">
							Proceed to secure checkout
						</a>
						<button class="button boring with-v-gap" @click="goToWithSeeds('search')">Back</button>
						<img class="accepted-cards with-v-gap" src="../../../assets/img/accepted_cards.png" alt="Accepted payment cards">
						<div class="powered-by with-v-gap">
							<a href="https://stripe.com/gb" target="_blank">
								<img src="../../../assets/img/powered-by-stripe-solid-dark.svg" width="130"/>
							</a>
						</div>
					</div>
				</div>

			</div>

			<p class="dull">
				Please check wording, dates and images of your Ents24 event pages for accuracy before booking, as we'll use this information when
				promoting
				it and will direct people here to book. It is your responsibility to report any amends needed
				<a href="mailto:backstage@ents24.com" target="_blank">here</a> before booking.
			</p>
		</div>

		<TermsFooter/>
	</div>
</template>

<script>
    import TermsFooter from '../TermsFooter';
    import axios from 'axios';
    import { EventBus }      from '../../event-bus';
    import basketHolderMixin from '../../mixins/basketHolder.js'
    import { formatPriceLabel } from '../../string-utils.js'

    export default {
        mixins: [
            basketHolderMixin
        ],
        props: [
            'promotion', 'config'
        ],
        components: {
            TermsFooter
        },
        data() {
            return {}
        },
        computed: {
            addOns() {
                if (!this.basket.addOns) {
                    return []
                }

                return this.basket.addOns.map(this.getAddOnFromName)
            },
            itemizedList() {
                let list = [
                    {
                        name: 'Boost Promotion',
                        costLabel: this.boostPromotionCostLabel,
                        vatLabel: this.boostPromotionVatLabel,
                    }
                ]

                if (this.addOns.length > 0) {
                    list.push({
                        name: 'Add-ons',
                        costLabel: this.addOnCostLabel,
                        vatLabel: this.addOnVatLabel,
                    })
                }

                return list
            },

            boostPromotionCostLabel() {
                const foundBundle = this.findBundleByImpressionCount(this.basket.impressions)
                return formatPriceLabel(foundBundle.netPrice)
            },
            boostPromotionVatLabel() {
                const foundBundle = this.findBundleByImpressionCount(this.basket.impressions)
                return formatPriceLabel(foundBundle.vatPrice)
            },
            addOnCostLabel() {
                let netValue = 0

                this.addOns.forEach(addOn => {
                    netValue += addOn.netPrice
                })

                return formatPriceLabel(netValue)
            },
            addOnVatLabel() {
                let netValue = 0

                this.addOns.forEach(addOn => {
                    netValue += addOn.vatPrice
                })

                return formatPriceLabel(netValue)
            },
            netPriceLabel() {
                const foundBundle = this.findBundleByImpressionCount(this.basket.impressions)
                let netValue = foundBundle.netPrice

                this.addOns.forEach(addOn => {
                    netValue += addOn.netPrice
                })

                return formatPriceLabel(netValue)
            },
            vatPriceLabel() {
                const foundBundle = this.findBundleByImpressionCount(this.basket.impressions)
                let netValue = foundBundle.vatPrice

                this.addOns.forEach(addOn => {
                    netValue += addOn.vatPrice
                })

                return formatPriceLabel(netValue)
            },
        },
        methods: {
            getAddOnFromName(name) {
                let found = null

                this.config.availableAddOns.forEach(addOn => {
                    if (addOn.name === name) {
                        found = addOn
                    }
                })

                return found
            },
            /**
             * Return the subset of app data to persist
             * @return {Object}          The promotion fields to save
             */
            getPayload() {
                return {
                    entitySeeds: this.basket.seeds,
                    addOnNames: this.basket.addOns,
                    impressions: this.basket.impressions,
                    startDate: this.basket.startIso,
                    endDate: this.basket.endIso,
                }
            },
            async beginPayment() {
                const stripe = Stripe(this.config.apiKeys.stripe);
                let stripeSessionId = null;

                // TODO: Show loading spinner on the buy button

                await axios.post(
                    this.$baseApiUrl + '/create',
                    this.getPayload()
                )
                    .then(response => {
                        stripeSessionId = response.data.data.stripeSessionId
                    })
                    .catch(error => {
                        let customError = {
                            message: error.message
                        }

                        if(error.response.status === 422) {
                            // Show the validation error message
                            customError.message = error.response.data.msg
                        }

                        EventBus.$emit('error', customError)
                        console.error(error);
                    });

                if(!stripeSessionId) {
                    return;
                }

                stripe.redirectToCheckout({
                    sessionId: stripeSessionId
                }).then((result) => {
                    console.error(result.error.message)
                });
            },
            findBundleByImpressionCount(impressions) {
                return this.config.bundles.find((bundle) => {
                    return bundle.impressions === impressions
                })
            }
        },
    }
</script>

<style lang="scss" scoped>
	@import '../../../assets/scss/var';

	.promo-summary {
		background : white;
		color      : black;
		padding    : $gap-large $gap-large 1px $gap-large; // XK: 1px prevents last child margin collapse

		.column-container {
			margin-bottom: $gap-large;
		}

		@media only screen and (min-width: 600px) {
			.column-container {
				display: flex;

				.promotion-contents,
				.payment-column {
					display: flex;
					flex-direction: column;
					flex: 1;
				}

				.promotion-contents {
					margin-right: $gap-large;
					border-right: 1px solid $color-grey-mid;
				}
			}
		}

		.selected-entities ul {
			display        : flex;
			flex-direction : column;

			.what {
				font-size : 1.2rem;
			}
		}

		.selected-promotion {
			text-align: left;
		}

		// Overrides buttons.scss
		button, .button {
			display      : block;
			font-size    : 1.2rem;
			margin-left  : auto;
			margin-right : auto;
			padding      : 12px;
			width        : 100%;

			&.pay {
				color    : $color-white;
				position : relative;

				.loading {
					height   : 25px;
					margin   : 0;
					position : absolute;
					right    : 16px;
					top      : 16px;
					width    : 25px;
				}
			}

			&.boring {
				border-color: $color-grey-v-light;
				color: $color-grey-v-light !important;
			}
		}

		.payment {
			table {
				border-collapse: collapse;
				width: 100%;
				margin-bottom: $gap-large;
			}

			th {
				border-bottom: 1px solid $color-grey-mid;
			}
		}

		.price-big {
			font-size   : 3.5rem;
			font-weight : 300;
			margin-bottom: $gap-default;
		}

		.price-small {
			font-size   : 1.25rem;
			font-weight : 100;
		}

		.powered-by a {
			// Remove descenders gap below stripe img
			display: block;
			line-height: 0;
		}

		img.accepted-cards {
			max-width: 190px;
		}
	}

	span.stripe {
		background: url(../../../assets/img/stripe-logo-black.svg) center bottom no-repeat;
		background-size: 97px;
		display: inline-block;
		height: 45px;
		position: relative;
		top: 14px;
		width: 80px;
	}

	@media only screen and (min-width: 600px) {
		p {
			max-width: 560px;
			margin-left: auto;
			margin-right: auto;
		}
	}
</style>
